//@flow
import MultiDayWeekSlot from 'common/entity/components/multiDaySlot/MultiDayWeekSlot';
import weekSlotsSelectorFactory from 'common/entity/components/slot/WeekSlotsSelector';

export const MultiDayWeekSlotsSelector = weekSlotsSelectorFactory(
    MultiDayWeekSlot
);

export default MultiDayWeekSlotsSelector;
